import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ZeitUI from '@zeit-ui/vue'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
import Datetime from 'vue-datetime'

import '@zeit-ui/vue/dist/zeit-ui.css'
import 'vue-select/dist/vue-select.css'
import 'vue-datetime/dist/vue-datetime.css'
import router from './router'

Vue.config.productionTip = false

Vue.use(ZeitUI)
Vue.use(Datetime)

Vue.component('v-select', vSelect)
Vue.component('apexchart', VueApexCharts)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
